import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../../util/theme';

const CtaBarModalWindow = styled.div`
  position: relative;

  height: 100vh;
  width: 95vw;

  overflow: scroll;

  background-color: ${getColor('white')};

  @media (min-width: ${getBreakpoint('xl')}) {
    height: auto;
    width: 50vw;

    overflow: hidden;
  }

  h4 {
    display: inline;
    padding: 0 15px;
  }

  hr {
    margin: 15px 0;
  }

  img {
    display: block;
    margin: 0 auto;
    position: relative;
  }

  h4 {
    font-size: 18px;
  }
`;

export default CtaBarModalWindow;
